import React from 'react';
import PropTypes from "prop-types";
import { useNavigate } from 'react-router';
import { govHubSubPath } from '../../utils/utils.js';
//import { MdShoppingCart } from "react-icons/md";
import IconNav from './icon-nav.js';

function ShoppingCart({ iconMenu}) {
    const navigate = useNavigate();

    const handleClick = () => {
        return navigate("/" + govHubSubPath + "/checkout");
    }
    return (
        iconMenu &&
        <IconNav
            //label="View Cart"
            label={iconMenu.subheader}
            handleClick={handleClick}>
            {/*<MdShoppingCart />*/}
            {iconMenu.icon}
        </IconNav>
    );
}

export default ShoppingCart;
ShoppingCart.propTypes = {
    iconMenu: PropTypes.object.isRequired,
};